import React, { useEffect } from 'react'
import { Col, Dropdown, Row } from 'react-bootstrap';
import cx from './companyPortfolio.module.scss';
import { dotMenu } from 'src/assets/images';
import CompanyCard from 'src/components/MarketPlace/CompanyCard/CompanyCard';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TGetCompany } from 'src/services/apiEndpoint.types.ts';
import { changeCreationModalState, clearMarketPlaceItems, getCommonMarketPlaceItems } from 'src/store/marketplace/marketplace.slice';
import CommonMarketplaceModal from 'src/components/MarketPlace/CommonMarketplaceModal/CommonMarketplaceModal';
import { Button, Loader } from 'src/components/common';
import { MdAdd } from 'react-icons/md';
import { useUrlParamValue } from 'src/hooks';

export default function CompanyPortfolio({ isViewerProgramCreator = true }: { isViewerProgramCreator?: boolean }) {
    const dispatch = useAppDispatch();
    const { paramValue } = useUrlParamValue();
    const { serviceProviderCommonModal, Portfolio, globalLoading } = useAppSelector((state) => state.marketPlace);
    const {
        myCompany
    }: {
        myCompany: TGetCompany;
    } = useAppSelector((store) => store.company);
    const viewCompanyId = paramValue({ paramName: 'id' }) as unknown as string;
    const handlePortfolioAdd = () => {
        dispatch(changeCreationModalState({ state: true, dataType: 'Portfolio', id: '' }))
    }
    useEffect(() => {
        if (myCompany?.id && !viewCompanyId) {
            const payload = {
                dataType: 'Portfolio',
                companyId: myCompany?.id
            }
            dispatch(getCommonMarketPlaceItems(payload))
        }
    }, [myCompany?.id, dispatch])

    useEffect(() => {
        if (viewCompanyId) {
            const payload = {
                dataType: 'Portfolio',
                companyId: viewCompanyId
            }
            dispatch(getCommonMarketPlaceItems(payload))
        }
    }, [viewCompanyId, dispatch])

    useEffect(() => {
        return () => {
            dispatch(clearMarketPlaceItems({ type: 'Portfolio' }))
            dispatch(changeCreationModalState({ state: false, dataType: '', id: '' }))
        }
    }, [])
    if (globalLoading === 'Portfolio') {
        return <Loader />
    }

    return (
        <>
            {serviceProviderCommonModal.state && <CommonMarketplaceModal />}
            <div className={`${cx.companyPortfolio}`}>
                <Row>
                    <Col md={12}>
                        <div className={`${cx.portfolioDetails}`}>
                            <h5 className={`${cx.portfolioName}`}>Protfolio</h5>
                            {isViewerProgramCreator && <Button
                                variant="secondary"
                                size="small"
                                className="create-edit-group__buttons__close"
                                onClick={() => handlePortfolioAdd()}
                            >
                                <MdAdd /> Add Portfolio
                            </Button>}
                        </div>
                    </Col>
                    <Col md={12}>
                        <div className={`${cx.serviceRow}`}>
                            <Row>
                                {Portfolio?.map((portfolio, p: number) => {
                                    const { id, title, thumbnailUrl, description, mediaUrl } = portfolio
                                    return (
                                        <Col md={4} key={p}>
                                            <CompanyCard type='Product' isViewerProgramCreator={isViewerProgramCreator} url={mediaUrl} id={id} dataType='Portfolio' key={p} logo={thumbnailUrl} name={title} description={description} />
                                        </Col>
                                    )
                                })}
                            </Row>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}
